import { createRoute } from "@tanstack/react-router";
import { customerLayoutRoute } from "../../Dashboard";
import { z } from "zod";

export const endUsersRoute = createRoute({
  getParentRoute: () => customerLayoutRoute,
  path: "end-users",
  validateSearch: z.object({
    search: z.string().optional(),
    after: z.string().optional(),
    before: z.string().optional(),
    segments: z.string().optional(),
  }),
}).lazy(() => import("./index.lazy").then((d) => d.Route));

export const endUserDetailRoute = createRoute({
  getParentRoute: () => customerLayoutRoute,
  path: "end-users/$endUserId",
}).lazy(() => import("./EndUserDetail").then((d) => d.Route));
